import React from 'react';

import FloatingWindow from './common/FloatingWindow';

import './HelpWindow.css';


const HelpWindow = ( props ) => {

  // get props
  // globalState = [ currentChar, setChar, loggedIn, layout, setLayout, currentSpellArray, currentSpellDataArray, allSpellsArray ];

  // const src=props.src;
  let layout = props.state[3] || "full"
  if (layout === "mobile-DM") {
    layout = "mobile"
  }
  const classAppend = "-" + layout
  // const classAppend='-mobile'

  return(
    <FloatingWindow title={"How To Use"} id="helpWindow" className={"home"+classAppend + " no-print"}>
      <h1 className='help-title'>Advanced Dungeon Master</h1>
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">LOG IN </span>{"[Settings > Log In]"} </h3>Do this first so you can save your character. Discord account is required.
      </div>
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">CHANGE CAMPAIGN </span>{"[Settings > Change Campaign]"} </h3>Create a new campaign or select one you've already created
      </div>
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">SELECT CHARACTER </span>{"[Characters]"} </h3>
          {"Select a character you've already saved, or create a new one using Characters > Roll New"}
      </div>
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">EDIT CHARACTER </span>{""} </h3>
          {"Most fields are directly editable in the form, and you can type in any text value you like."}
      </div>
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">CLICK FOR DESCRIPTIONS </span>{""} </h3>
          {"Some fields - Weapons, Armor, Potions, Magic Items, and Spells - can be clicked on to get a description of the item"}
      </div>
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">EDIT MODE </span>{"[click on a header]"} </h3>
        <>
          {"Click on any of the Weapons, Armor, Potions, Magic Item, or Spells headers to enter edit mode. "}
          {"Fields will turn green to indicate that you're in edit mode. This allows you to edit clickable fields. Click on a header again to exit edit mode. "}
          <br /><br />
          {"If you changed class or level during edit mode, saving throws will be recalculated"}
        </>
      </div>
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">SAVE CHARACTER </span>{"[Load/Save > Save]"} </h3>
        {"Use the Load/Save button to save character. "}<b>If you don't do this, your changes won't be saved.</b>
        <br />
        {"To rename your character, simply save as a different name, then delete the old character."}
      </div>
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">PRINT </span>{""} </h3>
        {"Use the browser's print function to print to paper. Settings > View > Portait is designed for this."}
      </div>
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">RULES & SPELLS </span>{"[Rules, Spells]"} </h3>
        {"Look up select rules and all spells via the RULES & SPELLS buttons. Some of these are homebrew"}
      </div>   
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">ROLL DICE </span>{"[Roll Dice]"} </h3>
        {"The up and down buttons determine how many of each die to roll. Roll Dice rolls the dice. Clear All sets everything to zero. "}
        {"See results in the Rolls section"}
      </div> 
      <div className='help-text-section'>
        <h3><span className="help-section-emphasis">TOGGLE POPUPS </span>{""} </h3>
        {"Many windows, such as Rules, Roll Dice and Settings, are toggled on/off by clicking on the button a second time"}
      </div>      

    </FloatingWindow>
  )
};

export default HelpWindow;